import type { UserRiskGroup } from '@/hooks/user-risk-group-types'

import { useFeatureFlag } from '@moment/app-config-ui'
import { useSormQuery } from '@moment/sorm-client-data-access/query-options'

import { TRADING_GROUP_OBJECT_ACCESS } from '@/app/feature-flags'
import { userTradingGroupsQuery } from '@/hooks/user-trading-groups-query'
import { useGetRiskGroupsQuery } from '@/legacy-api/risk-slice'
import { useGetSelfQuery } from '@/legacy-api/user-slice'

const EMPTY_RISK_GROUPS: UserRiskGroup[] = []

interface RiskGroupResponse {
  riskGroupId: string
  riskGroups: UserRiskGroup[]
  isLoading: boolean
  isError: boolean
}
export function useUserRiskGroupId(): RiskGroupResponse {
  const isTradingGroupAccessEnabled = useFeatureFlag(
    TRADING_GROUP_OBJECT_ACCESS,
  )
  const selfQuery = useGetSelfQuery()
  const currentUser = selfQuery.data
  const introducingBrokerId = currentUser?.organization_id || ''

  const riskGroupQuery = useGetRiskGroupsQuery(introducingBrokerId, {
    skip: isTradingGroupAccessEnabled || !introducingBrokerId,
  })
  const tradingGroupQuery = useSormQuery(userTradingGroupsQuery, {
    strictFields: true,
    enabled: isTradingGroupAccessEnabled,
  })
  const groupsQuery = isTradingGroupAccessEnabled
    ? tradingGroupQuery
    : riskGroupQuery

  const riskGroups: UserRiskGroup[] = groupsQuery.data ?? EMPTY_RISK_GROUPS
  // Both sources list the default first
  const riskGroupId = riskGroups[0]?.id ?? ''

  return {
    riskGroupId,
    riskGroups,
    isLoading: selfQuery.isLoading || groupsQuery.isLoading,
    isError: selfQuery.isError || groupsQuery.isError,
  }
}
